(() => {
  const form = document.querySelector('[data-header-search]');
  if (!form) return;
  const input = form.querySelector('input[name="q"]');
  const panel = form.querySelector('[data-search-suggestions]');
  const status = form.querySelector('[data-search-status]');
  let timer, controller, sequence = 0, active = -1;
  const options = () => [...panel.querySelectorAll('[role="option"]')];
  const normalize = text => String(text || '').normalize('NFKC').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  function score(element, term) {
    const query = normalize(term);
    const aliases = (element.dataset.searchAliases || '').split('|').map(normalize);
    const title = normalize(element.dataset.searchTitle);
    if (!query) return 0;
    if (aliases.includes(query)) return 100;
    if ((' ' + title + ' ').includes(' ' + query + ' ')) return 90;
    if (title.startsWith(query)) return 80;
    if (query.split(' ').every(word => title.split(' ').some(part => part.startsWith(word)))) return 70;
    if (aliases.some(alias => alias.startsWith(query))) return 60;
    return 0;
  }
  function rank(elements, term) {
    return elements.map((element,index)=>({element,index,score:score(element,term)}))
      .sort((a,b)=>b.score-a.score || a.index-b.index).map(item=>item.element);
  }
  if (document.body.classList.contains('template-search')) {
    const grid = document.getElementById('productsGrid');
    const cards = grid ? [...grid.querySelectorAll('[data-product-card]')] : [];
    if (cards.length) grid.append(...rank(cards, input.value));
  }
  function close() {
    panel.hidden = true;
    input.setAttribute('aria-expanded', 'false');
    input.removeAttribute('aria-activedescendant');
    options().forEach(option => option.setAttribute('aria-selected', 'false'));
    active = -1;
  }
  function select(index) {
    const links = options();
    if (!links.length) return;
    active = (index + links.length) % links.length;
    links.forEach((link, i) => link.setAttribute('aria-selected', String(i === active)));
    input.setAttribute('aria-activedescendant', links[active].id);
    links[active].scrollIntoView({block: 'nearest'});
  }
  async function suggest() {
    const term = input.value.trim(), ticket = ++sequence;
    controller?.abort();
    if (term.length < 2) { close(); return; }
    controller = new AbortController();
    const url = new URL(form.dataset.suggestUrl, location.origin);
    url.searchParams.set('q', term);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '6');
    url.searchParams.set('resources[options][unavailable_products]', 'last');
    url.searchParams.set('section_id', 'predictive-search');
    try {
      const response = await fetch(url, {signal: controller.signal, headers: {'Accept':'text/html'}});
      if (!response.ok) throw new Error('Search unavailable');
      const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = documentResult.querySelector('#af-predictive-section');
      if (ticket !== sequence || term !== input.value.trim()) return;
      if (!result) { close(); return; }
      const list = result.querySelector('[role="listbox"]');
      if (list) {
        const links = [...list.querySelectorAll('[role="option"]')];
        rank(links, term).forEach(link => list.append(link.closest('li')));
      }
      panel.replaceChildren(result);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
      status.textContent = form.dataset.resultsLabel.replace('[count]', String(options().length));
    } catch (error) {
      if (error.name !== 'AbortError' && ticket === sequence) close();
    }
  }
  input.addEventListener('input', () => {
    clearTimeout(timer);
    ++sequence;
    controller?.abort();
    close();
    timer = setTimeout(suggest, 220);
  });
  input.addEventListener('focus', () => { if (input.value.trim().length >= 2) suggest(); });
  input.addEventListener('keydown', event => {
    if (event.key === 'Escape') { close(); return; }
    if (panel.hidden) return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      select(active + (event.key === 'ArrowDown' ? 1 : -1));
    }
    if (event.key === 'Enter' && active >= 0) {
      event.preventDefault();
      location.assign(options()[active].href);
    }
  });
  document.addEventListener('click', event => {
    if (!form.contains(event.target)) close();
    document.querySelectorAll('[data-category-disclosure][open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-category-disclosure][open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.querySelectorAll('[data-focus-search]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    if (typeof window.closeMobSidebar === 'function') window.closeMobSidebar();
    input.focus();
    input.scrollIntoView({block: 'center', behavior: 'smooth'});
  }));
  const sidebar = document.getElementById('mobSidebar');
  let previousFocus;
  if (sidebar) {
    new MutationObserver(() => {
      const open = sidebar.getAttribute('aria-hidden') === 'false';
      document.querySelectorAll('[data-mob-open]').forEach(button => button.setAttribute('aria-expanded', String(open)));
      if (open) {
        previousFocus = document.activeElement;
        sidebar.querySelector('[data-mob-close]')?.focus();
      } else if (sidebar.contains(document.activeElement)) previousFocus?.focus();
    }).observe(sidebar, {attributes: true, attributeFilter: ['aria-hidden']});
    sidebar.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = [...sidebar.querySelectorAll('a[href],button')].filter(element => element.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }
})();
